import { useParams } from 'react-router-dom';
import { ReportsSaleCostAdjustmentsPage } from 'src/components/ReportsSaleCostAdjustmentsPage/ReportsSaleCostAdjustmentsPage';
import { Content } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { WarningMessage } from 'src/core/POS/MessageWithIcon';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useReportConfigsV2 } from 'src/hooks/reportConfigs';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';
import { ReportTypesV2 } from 'src/utils/reportsUtils';

import { MainRoute } from '../MainRoute';
import { ReportsSaleCostAdjustmentsContextProviderV2 } from './ReportsSaleCostAdjustmentsContextProviderV2';

export function ReportsSaleCostAdjustments() {
  return (
    <LayoutContent mainRoute={MainRoute.ReportsV2}>
      <ReportsSaleCostAdjustmentsContent />
    </LayoutContent>
  );
}

function ReportsSaleCostAdjustmentsContent() {
  const { reportId } = useParams();
  const { reportConfigs, isLoading, isFetching } = useReportConfigsV2({
    reportTypes: [ReportTypesV2.SaleCostAdjustments],
  });

  const reportConfig = reportConfigs?.find(
    (r) => r.reportId?.toString() === reportId
  );

  if (reportConfig == null) {
    return isLoading || isFetching ? (
      <PosSpinner />
    ) : (
      <Stack
        width="full"
        direction="column"
        alignItems="center"
        style={{ padding: vars.spacing.xxl }}
      >
        <WarningMessage
          message={<Content id={ContentId.ReportNotAvailable} />}
        />
      </Stack>
    );
  }

  return (
    <ReportsSaleCostAdjustmentsContextProviderV2 reportConfig={reportConfig}>
      <DialogProvider>
        <ReportsSaleCostAdjustmentsPage />
      </DialogProvider>
    </ReportsSaleCostAdjustmentsContextProviderV2>
  );
}
